import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'
import { isSuperAdmin } from '@/lib/authorization'

const MembersPage = lazy(() =>
  import('@/features/city-clerk/members/pages/MembersPage/MembersPage').then(
    (m) => ({ default: m.default }),
  ),
)

export const Route = createFileRoute('/(app)/city-clerk/members')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (isSuperAdmin(context.auth.userInfo)) {
      throw redirect({ to: '/superadmin/overview' })
    }
    if (!context.auth.userInfo?.uiCapabilities?.membersView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: MembersRoute,
})

function MembersRoute() {
  return (
    <Suspense
      fallback={
        <div className="h-page flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <MembersPage />
    </Suspense>
  )
}
